import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./report-criteria-form.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./report-criteria-form.component.scss?ngResource";
import { Component, ChangeDetectorRef, ChangeDetectionStrategy, Input, } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ReportCriteriaConst } from "./report-criteria-constants";
import { ExportTypeMap } from "../models/export-type-map.model";
import { ReportService } from "../report.service";
import { CriteriaFieldType } from "../models/criteria-type-field.model";
import { DatePipe } from "@angular/common";
import { UcFirstPipe } from "ngx-pipes";
import { ExportTypeConstants } from "../export-type.constants";
import { ReportParametersBuilder } from "./set-metadata-defaulet-values";
import { SharedConstants } from "../../../constants/shared.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let ReportCriteriaFormComponent = class ReportCriteriaFormComponent {
    formBuilder;
    appController;
    changeDetectorRefs;
    datePipe;
    ucFirst;
    reportService;
    reportList;
    reportListByGroupName;
    selectedReport;
    reportCriteriaFormGroup;
    reportGroupType;
    reportMetadata;
    reportParametersForm;
    countLoads = 0;
    showForm;
    show;
    disabled;
    selectReportGroup = ReportCriteriaConst.SELECT_REPORT_GROUP;
    selectReport = ReportCriteriaConst.SELECT_REPORT;
    selectFileExportType = ReportCriteriaConst.SELECT_FILE_EXPORT_TYPE;
    selectReportFielName = ReportCriteriaConst.SELECT_REPORT_FIELD_NAME;
    selectFileExportTypeFieldName = ReportCriteriaConst.SELECT_FILE_EXPORT_TYPE_FIELD_NAME;
    selectReportGroupFieldName = ReportCriteriaConst.SELECT_REPORT_GROUP_FIELD_NAME;
    submitBtnLbl = ReportCriteriaConst.SUBMIT_BTN_LBL;
    criteriaFieldValueError = SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION;
    criteriaFieldNumericValueError = SharedConstants.NUMERIC_INPUT_CONTROL_VALIDATION;
    criteriaFieldDecimalValueError = SharedConstants.DECIMAL_INPUT_CONTROL_VALIDATION;
    criteriaFieldValueControl = ReportCriteriaConst.CRITERIA_FIELD_VALUE_CONTROL;
    reportCriteriaControl = ReportCriteriaConst.REPORT_CRITERIA_CONTROL;
    reportDataInfoControl = ReportCriteriaConst.REPORT_DATA_INFO_CONTROL;
    exportTypeControl = ReportCriteriaConst.EXPORT_TYPE_CONTROL;
    reportGroupControl = ReportCriteriaConst.REPORT_GROUP_CONTROL;
    reportIdControl = ReportCriteriaConst.REPORT_ID_CONTROL;
    monthLbl = ReportCriteriaConst.MONTH_LBL;
    dayLbl = ReportCriteriaConst.DAY_LBL;
    monthsRegex = ReportCriteriaConst.MONTHS_REGEX;
    monthsRegexError = ReportCriteriaConst.MONTHS_REGEX_ERROR;
    monthError = ReportCriteriaConst.MONTH_ERROR;
    dayError = ReportCriteriaConst.DAY_ERROR;
    nonVisualPassToReportOnly = CriteriaFieldType.NonVisualPassToReportOnly;
    visualPassToReportOnly = CriteriaFieldType.VisualPassToReportOnly;
    nonVisualPassToSPOnly = CriteriaFieldType.NonVisualPassToSPOnly;
    image = CriteriaFieldType.Image;
    dateType = CriteriaFieldType.DateType;
    numericType = CriteriaFieldType.NumberType;
    stringType = CriteriaFieldType.StringType;
    dropDown = CriteriaFieldType.Dropdown;
    decimal = CriteriaFieldType.Decimal;
    timePeriodDropdown = CriteriaFieldType.TimePeriodDropdown;
    exportTypeMap;
    submited;
    reportId;
    reportGroup;
    submitFormListnerSubscription;
    getSelectedReportEventSubscription;
    getModuleValuationRollsSubscription;
    getModuleValuationRunSubscription;
    get reportCriteria() {
        return this.reportParametersForm.get(ReportCriteriaConst.REPORT_CRITERIA_CONTROL);
    }
    get reportCriteriaFgp() {
        return this.reportParametersForm.get(ReportCriteriaConst.REPORT_CRITERIA_CONTROL);
    }
    get reportDataInfo() {
        return this.reportParametersForm.get(ReportCriteriaConst.REPORT_DATA_INFO_CONTROL);
    }
    reportCriteriaRow = {};
    reportDataInfoRow = {};
    constructor(formBuilder, appController, changeDetectorRefs, datePipe, ucFirst, reportService) {
        this.formBuilder = formBuilder;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.datePipe = datePipe;
        this.ucFirst = ucFirst;
        this.reportService = reportService;
    }
    ngOnInit() {
        this.listenToReportChange();
        this.listenToFormSubmit();
    }
    handelReportChange(data) {
        if (data) {
            this.reportListByGroupName = data.reports;
            this.reportId = data.reportId;
            this.reportGroup = data.groupName;
            this.showForm = true;
            if (this.countLoads === 0 && this.reportMetadata) {
                this.getSelectedReport();
                this.initExportType();
                this.countLoads = 1;
            }
            else {
                this.onSelectReport();
                this.countLoads = 1;
            }
            this.changeDetectorRefs.detectChanges();
        }
    }
    listenToFormSubmit() {
        this.submitFormListnerSubscription = this.reportService.submitFormListner().subscribe(submit => {
            if (submit) {
                this.reportParametersForm.markAllAsTouched();
                this.changeDetectorRefs.markForCheck();
            }
        });
    }
    listenToReportChange() {
        this.getSelectedReportEventSubscription =
            this.reportService.getSelectedReportEvent()
                .subscribe((data) => {
                this.handelReportChange(data);
            });
    }
    seDefaultValues() {
    }
    // Form validation-tab setup section
    formSetup() {
        const form = this.formBuilder.group({
            CriteriaName: [this.reportCriteriaRow.CriteriaName],
            CriteriaFieldLabel: [this.reportCriteriaRow.CriteriaFieldLabel],
            CriteriaFieldType: [this.reportCriteriaRow.CriteriaFieldType],
            CriteriaFieldComparison: [this.reportCriteriaRow.CriteriaFieldComparison],
            CriteriaViewColumn: [this.reportCriteriaRow.CriteriaViewColumn],
            CriteriaFieldDefault: [this.reportCriteriaRow.CriteriaDefaultValue],
            DateFormat: [this.reportCriteriaRow.DateFormat],
        });
        return form;
    }
    getMetadata() {
        this.submited = false;
        this.disabled = false;
        const reportMetadata = {
            reportCriteria: new Array(),
            reportDataInfo: new Array(),
        };
        const obj = JSON.parse(this.selectedReport.metadata);
        if (obj) {
            if (obj.reportCriteria instanceof Array) {
                reportMetadata.reportCriteria =
                    obj.reportCriteria;
            }
            else {
                reportMetadata.reportCriteria.push(obj.reportCriteria);
            }
            if (obj.reportDataInfo instanceof Array) {
                reportMetadata.reportDataInfo =
                    obj.reportDataInfo;
            }
            else {
                reportMetadata.reportDataInfo.push(obj.reportDataInfo);
            }
        }
        return reportMetadata;
    }
    getSelectedReport() {
        this.selectedReport = this.reportListByGroupName.find((f) => f.id === +this.reportId);
    }
    initExportType() {
        this.exportTypeMap = new Map();
        ExportTypeMap.forEach((value, key) => {
            if (key === ExportTypeConstants.XLSX && this.selectedReport.excelUrl)
                this.exportTypeMap.set(key, value);
            if (key === ExportTypeConstants.PDF && this.selectedReport.url)
                this.exportTypeMap.set(key, value);
            if (key === ExportTypeConstants.DOCX && this.selectedReport.wordUrl)
                this.exportTypeMap.set(key, value);
        });
    }
    onSelectReport() {
        this.initForm();
        this.getSelectedReport();
        this.reportMetadata = this.getMetadata();
        this.loadCustomDropdown();
        const builder = this.initReportBuilder();
        builder.initMetadata();
        this.initExportType();
        this.changeDetectorRefs.detectChanges();
    }
    loadCustomDropdown() {
        this.reportMetadata.reportCriteria.forEach(reportCriteria => {
            if (reportCriteria.CriteriaFieldType.startsWith("CustomDropdown") && reportCriteria.CriteriaFieldType.endsWith("PvRoll")) {
                this.getModuleValuationRollsSubscription = this.reportService.getModuleValuationRolls(+this.appController.selectedModuleID).subscribe(x => {
                    reportCriteria.CriteriaDropDown = new Array();
                    x.forEach(el => {
                        reportCriteria.CriteriaDropDown.push({ Key: el.id, Value: `${el.projectCycle.name} - ${el.name}` });
                        this.changeDetectorRefs.detectChanges();
                    });
                });
                this.changeDetectorRefs.detectChanges();
            }
            else if (reportCriteria.CriteriaFieldType.startsWith("CustomDropdown") && reportCriteria.CriteriaFieldType.endsWith("PvRun")) {
                this.getModuleValuationRunSubscription = this.reportService.pvProjectCycle(+this.appController.selectedModuleID).subscribe(x => {
                    reportCriteria.CriteriaDropDown = new Array();
                    x.forEach(el => {
                        reportCriteria.CriteriaDropDown.push({ Key: el.id, Value: el.name });
                        this.changeDetectorRefs.detectChanges();
                    });
                });
                this.changeDetectorRefs.detectChanges();
            }
        });
    }
    initReportBuilder() {
        return new ReportParametersBuilder(this.ucFirst, this.datePipe, this.reportMetadata, this.reportParametersForm);
    }
    submitReportMetadata() {
        this.submited = true;
    }
    initForm() {
        while (this.reportCriteria.controls.length > 0) {
            this.reportCriteria.removeAt(0);
        }
        while (this.reportDataInfo.controls.length > 0) {
            this.reportDataInfo.removeAt(0);
        }
    }
    static ctorParameters = () => [
        { type: FormBuilder },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: DatePipe },
        { type: UcFirstPipe },
        { type: ReportService }
    ];
    static propDecorators = {
        reportMetadata: [{ type: Input }],
        reportParametersForm: [{ type: Input }]
    };
};
ReportCriteriaFormComponent = __decorate([
    Component({
        selector: "app-report-criteria-form",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ReportCriteriaFormComponent);
export { ReportCriteriaFormComponent };
